import React from "react";
import { styled } from "@mui/material/styles";
import SetMenu from "../../../../assets/images/order/setmenu.png";
import Soup from "../../../../assets/images/order/soup.png";
import { Avatar, Grid } from "@mui/material";

const items = [
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Salad", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
];

const FlexDivColumn = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const FlexDiv = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const Categories = ({ selectCategory }) => {
  const handleSelection = (value) => {
    selectCategory(value);
  };
  return (
    <div style={{ marginTop: 15, minWidth: 743 }}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {items.map((item, index) => (
          <SingleCard item={item} handleSelection={handleSelection} />
        ))}
      </Grid>
    </div>
  );
};

const SingleCard = ({ item, handleSelection }) => (
  <FlexDivColumn
    style={{
      background: "#FFF",
      width: 126,
      height: 111,
      borderRadius: 4,
      marginBottom: 20,
      boxShadow: "rgba(17, 17, 26, 0.1) 0px 1px 0px",
      cursor: "pointer",
    }}
    onClick={() => handleSelection(item.title)}
  >
    <Avatar
      sx={{
        width: "36px",
        height: "36px",
      }}
      variant="square"
      src={item.icon}
    />
    <div>{item.title}</div>
  </FlexDivColumn>
);

export default Categories;
